import {wrap} from '@codeurs/front'
import React from 'react'
import {PageData} from '../../types'
import {style} from '../../util/style'
import {Block, Blocks, BlockType} from '../blocks/Blocks'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {CardSwitchType} from '../layout/cards/CardSwitch'
import {PageCardType} from '../layout/cards/PageCard'
import {Hero, HeroType} from '../layout/Hero'
import {Layout} from '../layout/Layout'
import {Overview} from '../layout/Overview'

const styles = style('trips')

type TripsType = {
	hero: HeroType
	trips: Array<PageCardType>
	blocks?: Array<BlockType | {type: 'trips'}>
}

export const Trips: React.FC<PageData & TripsType> = wrap(Layout)(
	({...props}) => {
		const {parents, title, hero, trips, blocks} = props
		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} />
				<Breadcrumbs parents={parents} title={title} />
				<ProcessedBlocks blocks={blocks} trips={trips} />
			</div>
		)
	}
)

const ProcessedBlocks: React.FC<{
	blocks: Array<BlockType | {type: 'trips'}>
	trips: Array<CardSwitchType>
}> = ({blocks, trips}) => {
	if (!blocks || blocks.length === 0) return <Overview items={trips} />

	const processedBlocks: Array<BlockType> = blocks.map((block) => {
		if (block.type === 'trips')
			return {
				type: 'custom',
				render: () => (
					<Block>
						<Overview items={trips} />
					</Block>
				)
			}
		return block
	})

	return <Blocks blocks={processedBlocks} container={true} />
}
